import {Component, OnDestroy, OnInit, ViewChild, Renderer2 } from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {SearchParams} from '../../Interfaces/SearchParams';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {User} from '../../Interfaces/User';
import {QueryService} from '../../Services/query.service';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import { Subscription} from 'rxjs';
import {AppComponent} from '../../app.component';
import {ImportStatusView} from '../../Interfaces/ImportStatusView';
import {HoldsView} from '../../Interfaces/HoldsView';
import {BillOfLading} from '../../Interfaces/BillOfLading';
import NumberFormatOptions = Intl.NumberFormatOptions;
import {ListData} from '../../Interfaces/ListData';
import {SharedVarService} from '../shared-service.service';
import {HazardsView} from '../../Interfaces/HazardsView';
import * as XLSX from 'xlsx';
import {ImportStatusExcelView} from '../../Interfaces/ImportStatusExcelView';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';


@Component({
  selector: 'app-import-containers',
  templateUrl: './import-containers.component.html',
  styleUrls: ['./import-containers.component.css']
})


export class ImportContainersComponent implements OnInit, OnDestroy {

  public displayedColumns: string[];
  public qvColumns: string[];
  public holdsColumns: string[];
  public bolColumns: string[];
  public bolColumnsLineOp: string[];
  dataSource: MatTableDataSource<SearchParams>;
  quickViewData: MatTableDataSource<ImportStatusView>;
  holdsData: MatTableDataSource<HoldsView>;
  holdsData2: MatTableDataSource<HoldsView>;
  bolsData: MatTableDataSource<BillOfLading>;
  isv: ImportStatusView;
  public savedList: string;
  public savedLists : {id: string, code:string, description:string}[] = [];
  private  myUser: User;
  private clientRequest: ClientRequest;
  private impStatView: ImportStatusView[];
  private importStatusExcelArray: ImportStatusExcelView[] = [];
  private importStatusExcel: ImportStatusExcelView;
  private haz: HazardsView;
  hazardIndx: number;

  private listData: ListData[];
  private listDataObj: ListData;
  public containerNum: string;
  public didntEnterShit: boolean = false;
  public badChars: boolean = false;
  public insertNoConts: boolean = false;
  public noListName: boolean = false;
  public insertListExists: boolean = false;
  public showQuickView: boolean = false;
  public showDetailScreen: boolean = false;
  myNewListName: string = "";
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatTable) table22: MatTable<SearchParams>;
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild(MatSort) set content(sort: MatSort) {
    if (this.quickViewData!=undefined){
      this.quickViewData.sort = sort;
    }

  }

  @ViewChild(MatPaginator) set content2(pag: MatPaginator) {
    if (this.quickViewData!=undefined){
      this.quickViewData.paginator = pag;
    }

  }

  private  date1: Date;
  private  number1: number;
  private options: Intl.DateTimeFormatOptions = {month: "2-digit", day: "2-digit", year: "numeric", hour: "numeric",minute:"numeric",second:"numeric"};
  private options2: NumberFormatOptions = {maximumFractionDigits: 2};
  private options3: { currencyDisplay: string; style: string; currency: string }= {style: 'currency', currency : 'USD', currencyDisplay: 'symbol'};

  search1: UntypedFormControl;
  showAcc: boolean = false;
  showReeferInfo: boolean = false;
  showHoldsInfo: boolean = false;
  showHazInfo: boolean = false;
  showBillsInfo: boolean = false;
  showTruckerInfo: boolean = false;
  indexNumber: number = 1;
  workArray: SearchParams[] = [];
  qvArray: ImportStatusView[] = [];
  hArray: HoldsView[] = [];
  bolArray: BillOfLading[] = [];
  hold: HoldsView;
  bol: BillOfLading;
  searchObj: SearchParams;
  myForm: UntypedFormGroup;
  submitted = false;
  oneIsInAlready = false;
  submitted2 = false;
  badContainer = false;
  navisError: string;
  txtFromArea: string;
  txtArray2: string [] = [];
  subscription: Subscription;
  currentIndx: number;
  phoneApp: boolean = false;
  ipadApp: boolean = false;
  weight: string;
  freeDayCol: string = "Last Free Day";
  sub: any;
  public inSearch: boolean = false;
  public ipadAppear: boolean = true;




  enterHit() {
    // setTimeout(() => this.myInput.nativeElement.focus(),400);
  //   this.renderer.invokeElementMethod(this.myInput.nativeElement, 'focus');
 //   console.log(this.components.toArray());
 //   this.components.forEach((child) => { this.renderer.invokeElementMethod(child.nativeElement, 'focus'); })

  }

  clearAllInfo(){
    this.showHazInfo = false;
    this.showHoldsInfo = false;
    this.showReeferInfo = false;
    this.showBillsInfo = false;
    this.showTruckerInfo = false;

  }

  openReefer(){
    this.clearAllInfo();
    this.showAcc = false;
    setTimeout(() => {
      this.showAcc = true;
      this.showReeferInfo = true;
    },400);


  }

  openHolds(){
    this.clearAllInfo();
    this.showAcc = false;
    setTimeout(() => {
      this.showAcc = true;
      this.showHoldsInfo = true;
    }  ,400);
  }

  openhazards(){
    this.clearAllInfo();
    this.showAcc = false;
    setTimeout(() => {
      this.showAcc = true;
      this.showHazInfo = true;
    }  ,400);
  }


  openBills(){
    this.clearAllInfo();
    this.showAcc = false;
    setTimeout(() => {
      this.showAcc = true;
      this.showBillsInfo = true;
    }  ,400);
  }

  openTruckers(){
    this.clearAllInfo();
    this.showAcc = false;
    setTimeout(() => {
      this.showAcc = true;
      this.showTruckerInfo = true;
    }  ,400);
  }

  getColumnsToLookAtBOL(): string[] {
    if (this.myUser.role=="LINEOP"){
      return this.bolColumnsLineOp;
    }else{
      return this.bolColumns;
    }
  }

  returnToSearch(){
    if (this.ipadApp){
      this.inSearch = false;
      this.ipadAppear = true;
      this.showQuickView = false;
    }
  }


  exportExcel() {
    this.importStatusExcelArray = [];
    for (var xx=0; xx<this.quickViewData.filteredData.length; xx++){
      this.importStatusExcel = {} as ImportStatusExcelView ;
      this.importStatusExcel.Container = this.quickViewData.filteredData[xx].container;
      this.importStatusExcel.Available = this.quickViewData.filteredData[xx].available;
      this.importStatusExcel.SSL = this.quickViewData.filteredData[xx].line_id;
      this.importStatusExcel.ISO = this.quickViewData.filteredData[xx].iso_description;
      this.importStatusExcel.Freight = this.quickViewData.filteredData[xx].freight_kind_description;
      this.importStatusExcel.Discharged = this.quickViewData.filteredData[xx].received_date_fmt;
      this.importStatusExcel.VesselVoyage = this.quickViewData.filteredData[xx].vesselVoyage;
      this.importStatusExcel.Delivered = this.quickViewData.filteredData[xx].delivered_date_fmt;
      this.importStatusExcel.Customs = this.quickViewData.filteredData[xx].customs_released_description;
      this.importStatusExcel.FreightReleased = this.quickViewData.filteredData[xx].freight_released_fmt;
      this.importStatusExcel.LastFreeDay = this.quickViewData.filteredData[xx].fte_date_fmt;
      this.importStatusExcelArray.push(this.importStatusExcel);

    }



    const workSheet = XLSX.utils.json_to_sheet(this.importStatusExcelArray );
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    var wscols = [
      {wch:15},
      {wch:10},
      {wch:10},
      {wch:15},
      {wch:10},
      {wch:22},
      {wch:30},
      {wch:22},
      {wch:10},
      {wch:15},
      {wch:15},
    ];
    workSheet['!cols'] = wscols;
    XLSX.utils.book_append_sheet(workBook, workSheet, 'ImportStatusInquiry');
    XLSX.writeFile(workBook, 'importStatusInquiry.xlsx');
  }

  constructor(fb: UntypedFormBuilder,  private router: Router,private service: SharedVarService, private myApp:AppComponent, private renderer: Renderer2, private  globalEventsManager: GlobalEventsManager, private  queryService: QueryService) {
    this.myForm = fb.group({
      username: ['', [Validators.required]]});

    this.displayedColumns = ["container"];
    this.holdsColumns = ["type","code","description"];
    this.bolColumnsLineOp = ["nbr","customs","freight","shipper","consignee"];
    this.bolColumns = ["nbr","customs","freight"];
    this.qvColumns = ["container","available","line_id","iso_description","freight_kind_description","received_date_fmt","vesselVoyage","delivered_date_fmt","customs_released_description","freight_released_fmt","fte_date_fmt"];


    this.sub =  this.service.getConfirmed().subscribe((value) => {
      if (value){
        this.updateContainerList('D');
        this.service.setConfirmed(false);
      }
    });




    this.myUser = this.myApp.user;
    this.service.myUser = this.myUser;

/*
    this.myUser = {} as User;
    this.myUser.active ="Y"
    this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
    this.myUser.address_2 = null
      this.myUser.company_code ="EGN"
     this.myUser.company_code ="M0995"
    this.myUser.company_name= "MAHER TERMINALS, LLC"
    this.myUser.city= "HOUSTON"
    this.myUser.email_address= null
    this.myUser.fax_number= null
    this.myUser.first_name= "Csp Craig"
    this.myUser.last_name= "Miller"
    this.myUser. maherError= null
    this.myUser.old_password= null
    this.myUser.password= ""
    this.myUser.phone_number= null
    this.myUser.company_scac= null
    this.myUser.state= "TX"
    this.myUser.userMenuReportItemsView= null
    this.myUser.user_gkey= "8237887"
     this.myUser.role= "AGENT"
     this.myUser.menuRoleArray = [];
    //this.myUser.role= "LINEOP"
   // this.myUser.role= "CSP_PORT_AUTHORITY_ROLE"
    this.myUser.username="CDOUG"
 //   this.myUser.username="CSPSSL"
    this.myUser.zip="07201"
    this.myUser.canSeeAllData = "0";
    this.service.myUser = this.myUser;



 */

  }

  get f() { return this.myForm.controls;}



isPortAuthority(){
    if ((this.myUser.menuRoleArray.findIndex(xx => xx == "CSP_PORT_AUTHORITY_ROLE")!=-1) || this.myUser.menuRoleArray.findIndex(xx => xx == "CSP_DRIVER_ROLE")!=-1){
      return true;
    }else{
      return false;
    }
}

  whatsTheColSpan(isv: ImportStatusView): string{
    if (isv.demurrageBalanceDueLineFmt!=null && !isv.demurrageBalanceDueLineFmt.includes('Contact Line Op')){
      return "1"
    }else{
      return "2";
    }
  }


applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    this.quickViewData.filter = filterValue;
  }

  allowedToSeeUTCS(): boolean{
    if (this.myUser.role=='HAULIER'){
      return false;
    }else{
      return true;
    }
  }


  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  ngOnInit() {

    this.search1 = new UntypedFormControl();
    this.getListData();
    this.service.getAllSslStorageCollections(this.myUser);
    if (window.innerWidth > 750 && window.innerWidth <1290){
      this.ipadApp = true;
    }
    if (window.innerWidth <= 750){
      this.phoneApp = true;
    }

  }


  getListData(){
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];

    this.listData = []
    this.listDataObj = {} as ListData;
    this.listDataObj.type = "E";
    this.listData.push(this.listDataObj);
    this.clientRequest.requestData = this.listData;

    const lhsUserObs$ = this.queryService.getLists(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this.listData = lstConts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
          this.fillUpSavedLists();
      });

  }


  deleteHit(){
    this.myApp.showConfirmBanner("Confirm","confirm delete of list: "+this.savedLists[this.savedLists.findIndex(xx=>xx.id==this.savedList)].description,"importContainers");
    return;
  }

  updateContainerList(fromWhere: string){
    this.submitted2 = true;
    this.insertNoConts = false;
    this.noListName = false;
    this.insertListExists = false;
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.listDataObj = null;
    this.listDataObj =  {} as ListData;
    if (fromWhere=="D"){
      var indx = this.listData.findIndex(xx => xx.id == this.savedList);
      if (indx!=-1){
        this.listDataObj = this.listData[indx];
      }
      this.listDataObj.data = [];
      this.clientRequest.requestData = [];
      this.clientRequest.requestData[0] = this.listDataObj;
    }else{
      if (this.txtFromArea==undefined || this.txtFromArea==""){
        if (fromWhere=="I" || fromWhere=="U"){
          this.insertNoConts = true;
        }
        return;
      }
      if (fromWhere=="I" && (this.myNewListName==null || this.myNewListName=="")){
        this.noListName = true;
        return;
      }

      if ((fromWhere=="U" ) && (this.savedList==null || this.savedList=="")){
        this.noListName = true;
        return;
      }

      if (fromWhere=="I" &&  this.listData.findIndex(xx => xx.name == this.myNewListName && xx.type == "E") !=-1){
        this.insertListExists = true;
        return;
      }
      this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
      if (this.txtArray2.length==0){
        this.didntEnterShit = true;
        return;
      }
      this.didntEnterShit = false;
      var _i = this.txtArray2.length;
      while (_i--) {
        if (this.txtArray2[_i].valueOf() == "") {
          this.txtArray2.splice(_i, 1);
        }
      }

      if (fromWhere!="D"){
        if (fromWhere=="I"){
          this.listDataObj.name = this.myNewListName;
          this.listDataObj.type = "E";
        }else{
          var indx = this.listData.findIndex(xx => xx.id == this.savedList);
          if (indx!=-1){
            this.listDataObj = this.listData[indx];
          }
        }
        this.listDataObj.data = this.txtArray2;
        this.clientRequest.requestData = [];
        this.clientRequest.requestData[0] = this.listDataObj;
      }
    }

    this.clientRequest.user = this.myUser;

    const lhsUserObs$ = this.queryService.updateContainerList(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (lstConts) => {
        this.listData = lstConts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        var id = this.savedList;
        this.fillUpSavedLists();
        if (this.savedLists.length > 0) {
          if (fromWhere == "I") {
            this.savedList = this.savedLists[this.savedLists.findIndex(xx=> xx.code == this.myNewListName)].id;
          } else if (fromWhere== "D") {
            this.savedList = this.savedLists[0].id;
          }else{
            this.savedList = this.savedLists[this.savedLists.findIndex(xx=> xx.id == id)].id;
          }
        }
        this.myNewListName = "";

        if (fromWhere=="I"){
          this.myApp.showSuccessBanner("","the new list has been created successfully","importContainers");
        }else if (fromWhere=="D"){
          this.myApp.showSuccessBanner("",this.myNewListName + " has been deleted successfully","importContainers");
        }else{
          this.myApp.showSuccessBanner("","List has been updated successfully","importContainers");

        }

        this.submitted2= false;

      });

  }


  fillUpSavedLists(){
    this.savedLists = [];
    for (var item of this.listData){
      if (item.type == "E"){
        this.savedLists.push({"id": item.id, "code": item.name, "description": item.name});
      }
    }
    if (this.savedLists.length>0){
      this.savedList = this.savedLists[0].id;
    }
  }

  showContainersFromList(){
    var indx = this.listData.findIndex(xx => xx.id == this.savedList);
    if (indx!=-1){
      this.txtFromArea = "";
      for (var ii=0;ii<this.listData[indx].data.length; ii++){
        this.txtFromArea =  this.txtFromArea + this.listData[indx].data[ii].valueOf() + '\r\n';
      }
    }
  }

returnToQuery(){
  this.showQuickView = false;
  this.showDetailScreen = false;
}

  returnToQuickView(){
    this.showQuickView = true;
    this.showDetailScreen = false;
  }

  showDetails(rowIn: ImportStatusView){
      if (rowIn.maherError!=null){
        return;
      }

      this.currentIndx = this.impStatView.findIndex(xx => xx.container == rowIn.container);
      this.showQuickView = false;
      this.showDetailScreen = true;
      this.showAcc = false;
      this.isv = null;
      this.isv = {} as ImportStatusView;
      this.isv = rowIn;
      this.formatDetailScreen();
  }


  previousContainer(){
    this.currentIndx--;
    if (this.currentIndx>=0){
      for (var dd=this.currentIndx; dd<this.impStatView.length; dd--){
        if (this.impStatView[dd].maherError!=null) {
          this.currentIndx--;
        }else{
          break;
        }
      }
      this.isv = null;
      this.isv = {} as ImportStatusView;
      this.isv = this.impStatView[this.currentIndx];
      if (this.isv!=null){
        this.clearAllInfo();
        this.showAcc = false;
        this.formatDetailScreen();
      }else{
        this.currentIndx = this.impStatView.length;
      }
    }else{
      this.currentIndx=0;
    }

  }

  nextContainer(){
    this.currentIndx++;
    if (this.currentIndx<this.impStatView.length){
      for (var dd=this.currentIndx; dd<this.impStatView.length; dd++){
        if (this.impStatView[dd].maherError!=null) {
          this.currentIndx++;
        }else{
          break;
        }
      }

      this.isv = null;
      this.isv = {} as ImportStatusView;
      this.isv = this.impStatView[this.currentIndx];
      if (this.isv!=null){
        this.clearAllInfo();
        this.showAcc = false;
        this.formatDetailScreen();
      }
    }else{
      this.currentIndx=this.impStatView.length-1;
      var _i = this.impStatView.length;
      while (_i--) {
        if (this.impStatView[_i].maherError !=null) {
        } else {
          this.currentIndx = _i;
          break;
        }
      }
    }
  }

  getNiceDate(dateIn: string): string {
    this.date1 =  new Date(dateIn);
    return this.date1.toLocaleDateString("en-US", this.options);
  }



  getNiceWeight(weightIn: string): string {
    this.number1 = Number.parseInt(weightIn);
    return this.number1.toLocaleString("en-US", this.options2);
  }

  getNiceCurrency(numberIn: string): string {
    this.number1 = Number.parseFloat(numberIn);
    return this.number1.toLocaleString("en-US", this.options3);
  }




  getSearchItems(){

    if (this.oneIsInAlready){
      return;
    }
    this.showQuickView = false;
    this.showDetailScreen = false;
    this.submitted = true;
    this.oneIsInAlready = true;
    this.badContainer = false;
    this.badChars = false;
    if (this.txtFromArea==undefined){
      this.didntEnterShit = true;
      this.oneIsInAlready = false;
      return;
    }

    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');
    this.txtFromArea = this.txtFromArea.replace(" ",'\n');

    this.txtArray2 = this.txtFromArea.split(/[\r\n]+/);
    if (this.txtArray2.length==0){
      this.didntEnterShit = true;
      this.oneIsInAlready = false;
      return;
    }
    this.didntEnterShit = false;
    var _i = this.txtArray2.length;
    while (_i--) {
      this.txtArray2[_i] = this.txtArray2[_i].valueOf().trim();
      if (!this.service.checkForSpecialChars(this.txtArray2[_i].valueOf())) {
        this.containerNum = this.txtArray2[_i].valueOf();
        this.badChars = true;
        this.oneIsInAlready = false;

        return;
      }
      if (this.txtArray2[_i].valueOf() == "") {
        this.txtArray2.splice(_i, 1);
      }
    }
    this.txtArray2 = this.service.onlySendOneHundread(this.txtArray2);

    this.impStatView = [];
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    for (var items of this.txtArray2){
      this.isv = {} as ImportStatusView;
      this.isv.container = items.valueOf();
      if (this.impStatView.findIndex(xx => xx.container == this.isv.container)==-1){
        this.impStatView.push(this.isv);
      }
    }
    this.clientRequest.requestData = this.impStatView;


    const lhsUserObs$ = this.queryService.importInquiryQuery(this.clientRequest);
      this.subscription = lhsUserObs$.subscribe(
        (lhsUser) => {
          this.impStatView = lhsUser;
        },
        error => {
          if (error.status == "401") {
            this.globalEventsManager.showLogin.emit(true);

            this.router.navigate(["login"]);
          } else {
            this.myApp.openDialog(error.message)
          }
        },
        () => {
              this.oneIsInAlready = false;

              for (var item of this.impStatView){
                if (item.maherError!=null) {
                  item.vesselVoyage = item.maherError;
                }else if (item.navisErrors!=null && item.navisErrors.length>0){
                  for (var things of item.navisErrors){
                    item.vesselVoyage =  item.vesselVoyage + things;
                  }
                }else{
                  if (item.released=="1"){
                    item.released_fmt = "Yes";
                  }else{
                    item.released_fmt = "No";
                  }

                  if (item.freight_released=="1"){
                    item.freight_released_fmt = "Yes";
                  }else{
                    item.freight_released_fmt = "No";
                  }

                  if (item.vessel_description!=null){
                    item.vesselVoyage = item.vessel_description;
                  }
                  if (item.voyage!=null){
                    item.vesselVoyage = item.vesselVoyage + " / " + item.voyage;
                  }

                }

              }
              if (this.impStatView.length==1){
                if (this.impStatView[0].maherError!=null) {
                  this.badContainer = true;
                }else if (item.navisErrors!=null && item.navisErrors.length>0){
                  for (var things of item.navisErrors){
                    this.navisError = this.navisError + things;
                  }
                }else{
                  this.isv = this.impStatView[0];
                  this.formatDetailScreen();
                  this.showQuickView = false;
                  this.showDetailScreen = true;
                }

              }else{
                this.showQuickView = true;
                this.showDetailScreen = false;
                this.search1.reset();
                if (window.innerWidth > 750 && window.innerWidth <1150){
                  this.ipadAppear = false;
                }
                if (window.innerWidth < 800) {
                  this.freeDayCol = "Last Free";
                }else{
                  this.freeDayCol = "Last Free Day";
                }
                this.quickViewData = new MatTableDataSource<ImportStatusView>(this.impStatView);
                this.quickViewData.sortingDataAccessor = (item, property) => {
                  switch (property) {
                    case 'received_date_fmt': return new Date(item.received_date_fmt);
                    case 'delivered_date_fmt': return new Date(item.delivered_date_fmt);
                    case 'fte_date_fmt': return new Date(item.fte_date_fmt);
                    default: return item[property];
                  }
                };


              }
          this.submitted = false;





        });

    //  }
  }


  public wipeOutSearch(){
    this.txtFromArea = null;
    this.showQuickView = false;
    this.showDetailScreen = false;
  }


  newRow(rowIn: any, event){
//    if (rowIn.stringToFind.valueOf()!="" && rowIn.indexNumber==this.indexNumber) {
      this.indexNumber++;
      this.searchObj = {} as SearchParams;
      this.searchObj.stringToFind = "";
      this.searchObj.indexNumber = this.indexNumber.toString();
      this.workArray.push(this.searchObj);
      this.dataSource = new MatTableDataSource<any>(this.workArray);
      this.dataSource._updateChangeSubscription();

      this.enterHit();

  //  }
  }



  returnBack(){
    this.router.navigate([""]);

  }

  formatDetailScreen(){


    if (this.isv.container == null){
      this.isv.container = " ";
    }
    if (this.isv.line_description == null){
      this.isv.line_description = " ";
    }
    if (this.isv.freight_kind_description == null){
      this.isv.freight_kind_description = " ";
    }
    if (this.isv.commodity == null || this.isv.commodity == ''){
      this.isv.commodity = " ";
    }
    if (this.isv.iso_description == null){
      this.isv.iso_description = " ";
    }
    if (this.isv.lease_description == null){
      this.isv.lease_description = " ";
    }
    if (this.isv.group_code == null){
      this.isv.group_code = " ";
    }
    if (this.isv.onLienMessage == null){
      this.isv.onLienMessage = " ";
    }


    if (this.isv.gross_weight == null || this.isv.gross_weight == "0") {
      this.isv.gross_weightFmt = " ";
    } else {
      this.weight = this.getNiceWeight(this.isv.gross_weight);
      this.isv.gross_weightFmt =  this.weight + " kg / ";
      this.weight = this.getNiceWeight(this.isv.gross_weight_lbs);
      this.isv.gross_weightFmt = this.isv.gross_weightFmt + this.weight + " lbs";
    }
    if (this.isv.tare_weight == null || this.isv.tare_weight == "0") {
      this.isv.tare_weightFmt = " ";
    } else {
      this.weight = this.getNiceWeight(this.isv.tare_weight);
      this.isv.tare_weightFmt =  this.weight + " kg / ";
      this.weight = this.getNiceWeight(this.isv.tare_weight_lbs);
      this.isv.tare_weightFmt = this.isv.tare_weightFmt + this.weight + " lbs";
    }


    if (this.isv.cargo_weight == null || this.isv.cargo_weight == "0") {
      this.isv.cargo_weightFmt = " ";
    } else {
      this.weight = this.getNiceWeight(this.isv.cargo_weight);
      this.isv.cargo_weightFmt =  this.weight + " kg / ";
      this.weight = this.getNiceWeight(this.isv.cargo_weight_lbs);
      this.isv.cargo_weightFmt = this.isv.cargo_weightFmt + this.weight + " lbs";
    }
    if (this.isv.seal_1 == null){
      this.isv.seal_1 = " ";
    }
    if (this.isv.seal_2 == null){
      this.isv.seal_2 = " ";
    }
    if (this.isv.seal_3 == null){
      this.isv.seal_3 = " ";
    }
    if (this.isv.seal_4 == null){
      this.isv.seal_4 = " ";
    }

    if (this.isv.hazardous==null || this.isv.hazardous=="0" ){
      this.isv.hazardousFmt = "No";
    }else{
      this.isv.hazardousFmt = "Yes";
    }
    if (this.isv.requires_power==null || this.isv.requires_power == "0"){
      this.isv.requires_powerFmt = "No";
    }else{
      this.isv.requires_powerFmt = "Yes";
    }
    if (this.isv.holds==null || this.isv.holds == "0"){
      this.isv.holdsFmt = "No";
    }else{
      this.isv.holdsFmt = "Yes";
    }
    if (this.isv.vessel_description == null){
      this.isv.vessel_description = " ";
    }
    if (this.isv.voyage == null){
      this.isv.voyage = " ";
    }
    if (this.isv.pol_unloccode_description == null){
      this.isv.pol_unloccode_description = " ";
    }
    if (this.isv.customs_released == "0"){
      this.isv.customs_releasedFmt = "Yes";
    }else{
      this.isv.customs_releasedFmt = "No";
    }
    if (this.isv.freight_released == "0"){
      this.isv.freight_releasedFmt = "No";
    }else{
      this.isv.freight_releasedFmt = "Yes";
    }
    if (this.isv.usda_released == "0"){
      this.isv.usda_releasedFmt = "Yes";
    }else{
      this.isv.usda_releasedFmt = "No";
    }
    if (this.isv.other_agency_released == "0"){
      this.isv.other_agency_releasedFmt = "Yes";
    }else{
      this.isv.other_agency_releasedFmt = "No";
    }

    if (this.isv.last_pos_name == null){
      this.isv.last_pos_name =  " ";
    }
    if (this.isv.received_date_fmt == null){
      this.isv.received_date_fmt = " ";
    }else{
       if (this.isv.received_date_fmt.indexOf(" ")>0){
         this.isv.fte_start_date = this.isv.received_date_fmt.substring(0,this.isv.received_date_fmt.indexOf(" "));
       }
    }
    if (this.isv.fte_date == null || this.isv.fte_date==''){
      this.isv.fte_date_fmt = " ";
    }
    if (this.isv.demurrageDays == null){
      this.isv.demurrageDays = " ";
    }

    if (this.isv.demurrageBalanceDue == null){
      this.isv.demurrageBalanceDueFmt = " ";
    }else if (this.isv.demurrageBalanceDue != "TBD"){
      this.isv.demurrageBalanceDueFmt = this.getNiceCurrency(this.isv.demurrageBalanceDue);
    }

    if (this.isv.demurrageBalanceDueMaher!=null && this.isv.demurrageBalanceDueMaher!="" && this.isv.demurrageBalanceDueMaher != "TBD") {
      this.isv.demurrageBalanceDueMaherFmt = this.getNiceCurrency(this.isv.demurrageBalanceDueMaher);
    }

    var isDemLine = this.service.isAStorageSSL(this.isv.line_id);
    if (isDemLine=="L"){
      this.isv.demurrageBalanceDueLineFmt = null;
    }else if (isDemLine=="Y" && this.isv.demurrageBalanceDueLine!="" && this.isv.demurrageBalanceDueLine != "TBD"){
      this.isv.demurrageBalanceDueLineFmt = this.getNiceCurrency(this.isv.demurrageBalanceDueLine);
    }else{
      this.isv.demurrageBalanceDueLineFmt = "Contact Line Op For Demurrage Owed";
    }


    if (this.isv.powerBalanceDue == null){
      this.isv.powerBalanceDueFmt = " ";
    }else if (this.isv.powerBalanceDue != "TBD"){
      this.isv.powerBalanceDueFmt = this.getNiceCurrency(this.isv.powerBalanceDue);
    }
    if (this.isv.examChargesDue == null){
      this.isv.examChargesDueFmt = " ";
    }else if (this.isv.examChargesDue != "TBD"){
      this.isv.examChargesDueFmt = this.getNiceCurrency(this.isv.examChargesDue);
    }

    if (this.isv.delivered_date == null){
      this.isv.delivered_date_fmt = " ";
    }
    if (this.isv.out_mode == null){
      this.isv.out_mode = " ";
    }
    if (this.isv.out_visit == null){
      this.isv.out_visit = " ";
    }
    if (this.isv.out_transaction_number == null){
      this.isv.out_transaction_number = " ";
    }
    if (this.isv.out_trucker_description == null){
      this.isv.out_trucker_description = " ";
    }
    if (this.isv.driver_name == null){
      this.isv.driver_name = " ";
    }
    if (this.isv.trucker_status == null){
      this.isv.trucker_status = " ";
    }
    if (this.isv.account_status == null){
      this.isv.account_status = " ";
    }
    if (this.isv.insurance_expiration_date == null || this.isv.insurance_expiration_date == ""){
      this.isv.insurance_expiration_date_fmt = " ";
    }

    if (this.isv.credit_expiration_date == null || this.isv.credit_expiration_date == ""){
      this.isv.credit_expiration_date_fmt = " ";
    }

    if (this.isv.expiration_date == null || this.isv.expiration_date == ""){
      this.isv.expiration_date_fmt = " ";
    }


    if (this.isv.genset_requirement == null){
      this.isv.genset_requirement = " ";
    }
    if (this.isv.powerDays == null){
      this.isv.powerDays = " ";
    }

    if (this.isv.temp_reqd_f!=null){
      this.isv.temp_reqdFmt = this.isv.temp_reqd_f+" F";
    }
    if (this.isv.temp_reqd_c!=null){
      this.isv.temp_reqdFmt = this.isv.temp_reqdFmt  + " / "+this.isv.temp_reqd_c+" C";
    }

    if (this.isv.trucker_description == null){
      this.isv.trucker_description = " ";
    }
    if (this.isv.trucker_scac == null){
      this.isv.trucker_scac = " ";
    }
    this.bolArray = [];
    if (this.isv.billOfLadingsArray!= null){
      if (this.isv.billOfLadingsArray.length>0){
        for (var item of this.isv.billOfLadingsArray){
          this.bol = {} as BillOfLading;
          this.bol.nbr = item.nbr
          this.bol.consignee = item.consignee;
          this.bol.shipper = item.shipper;
          this.bol.customs = "No";
          this.bol.freight = "Yes";
          if (item.bolHolds!=null){
              if (item.bolHolds.length>0){
                  for (var bh of item.bolHolds){
                     if (bh.type=="CUSTOMS"){
                       this.bol.customs = "Yes";
                     }
                     if (bh.type=="STEAMSHIP LINE" && bh.code=="FREIGHT RELEASE"){
                       this.bol.freight = "No";
                     }
                  }
              }
          }


          this.bolArray.push(this.bol);
        }

      }
    }

    this.bolsData = new MatTableDataSource<BillOfLading>(this.bolArray);
    this.bolsData.sort = this.sort;

    this.hArray = [];
    for (var items of this.isv.billOfLadingsArray){
      for (var bolHolds of items.bolHolds){
        this.hold = {} as HoldsView;
        this.hold.type = bolHolds.type;
        this.hold.code = bolHolds.code;
        this.hold.description = bolHolds.description
        this.hArray.push(this.hold);
      }
    }

    if (this.isv.holdsArray!= null){
      if (this.isv.holdsArray.length>0){
        for (var item2 of this.isv.holdsArray){
          this.hold = {} as HoldsView;
          this.hold.type = item2.type
          this.hold.code = item2.code
          this.hold.description = item2.description;
          if (this.hArray.findIndex(xx => xx.code == this.hold.code)==-1){
            this.hArray.push(this.hold);
          }
        }

      }
    }
    if (this.isv.hazardsArray!=null) {
      if (this.isv.hazardsArray.length > 0) {
        this.formatHazards(0);
      }
    }

    this.holdsData = new MatTableDataSource<HoldsView>(this.hArray);
    this.holdsData2 = new MatTableDataSource<HoldsView>(this.hArray);
    this.holdsData.sort = this.sort;
  }


  nextHazard(){
    this.hazardIndx++;
    if (this.hazardIndx<this.isv.hazardsArray.length){
      this.haz = null;
      this.haz = {} as HazardsView;
      this.haz = this.isv.hazardsArray[this.hazardIndx];
      this.formatHazards(this.hazardIndx);
    }else{
      this.hazardIndx=this.isv.hazardsArray.length-1;
    }
  }

  previousHazard() {
    this.hazardIndx--;
    if (this.hazardIndx >= 0) {
      this.haz = null;
      this.haz = {} as HazardsView;
      this.haz = this.isv.hazardsArray[this.hazardIndx];
      this.formatHazards(this.hazardIndx);
    } else {
      this.hazardIndx = 0;
    }
  }


  formatHazards(indxIn: number){
    if (indxIn==0){
      this.haz = {} as HazardsView;
      if (this.isv.hazardsArray!=null) {
        if (this.isv.hazardsArray.length > 0) {
          this.haz = this.isv.hazardsArray[0];
        }
      }
    }
    if (this.haz.imdg_class == null) {
      this.haz.imdg_class = " ";
    }

    if (this.haz.imdg_description == null) {
      this.haz.imdg_description = " ";
    }

    this.haz.imdgConcat = this.haz.imdg_class + " - " + this.haz.imdg_description;


    if (this.haz.proper_name == null) {
      this.haz.proper_name = " ";
    }
    if (this.haz.hzrdi_nbr_type == null) {
      this.haz.hzrdi_nbr_type = " ";
    }
    if (this.haz.quantity == null) {
      this.haz.quantity = " ";
    }
    if (this.haz.package_type == null) {
      this.haz.package_type = " ";
    }

    if (this.haz.weight == null || this.haz.weight == "0") {
      this.haz.weightDisp = " ";
    } else {
      this.weight = this.getNiceWeight(this.haz.weight);
      this.haz.weightDisp =  this.weight + " kg / ";
      this.weight = this.getNiceWeight(this.haz.weight_lbs);
      this.haz.weightDisp = this.haz.weightDisp + this.weight + " lbs";
    }


    if (this.haz.marine_pollutants == '0') {
      this.haz.marine_pollutants = "No";
    } else {
      this.haz.marine_pollutants = "Yes";
    }
    if (this.haz.tech_name == null) {
      this.haz.tech_name = " ";
    }
    if (this.haz.undg == null) {
      this.haz.undg = " ";
    }
    if (this.haz.hzrdi_nbr_type == null) {
      this.haz.hzrdi_nbr_type = " ";
    }
    this.haz.undgTypeConcat = this.haz.undg + " - " + this.haz.hzrdi_nbr_type;

    if (this.haz.flashpoint_f == null){
      this.haz.flashpoint_fmt = " ";
    }else{
      if (this.haz.flashpoint_f!=null){
        this.haz.flashpoint_fmt = this.haz.flashpoint_f+"F";
      }
      if (this.haz.flashpoint_c!=null){
        this.haz.flashpoint_fmt = this.haz.flashpoint_fmt + " / "+this.haz.flashpoint_c+"C";
      }
    }

    if (this.haz.package_group == null) {
      this.haz.package_group = " ";
    }
    if (this.haz.emergency_telephone_fmt == null) {
      this.haz.emergency_telephone_fmt = " ";
    }
    if (this.haz.notes == null) {
      this.haz.notes = " ";
    }

  }


}


